import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker, Input, Button, Form, Select } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

function AnalysisOptions() {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    const queryParams = new URLSearchParams();

    if (values.tickers) {
      queryParams.append('symbols', values.tickers.join(','));
    }

    if (values.dateRange) {
      queryParams.append('start_date', values.dateRange[0].format('YYYY-MM-DD'));
      queryParams.append('end_date', values.dateRange[1].format('YYYY-MM-DD'));
    }

    navigate(`/beta/analysis/cluster?${queryParams.toString()}`);
  };

  return (
    <Form form={form} onFinish={handleSubmit} layout="vertical">
      <h2>Analysis Options</h2>

      <Form.Item name="tickers" label="Tickers">
        <Select mode="tags" style={{ width: '100%' }} placeholder="Enter tickers" />
      </Form.Item>

      <Form.Item name="dateRange" label="Date Range">
        <RangePicker style={{ width: '100%' }} />
      </Form.Item>

      {/* Add other parameter inputs here using Form.Item */}

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Run Analysis
        </Button>
      </Form.Item>
    </Form>
  );
}

export default AnalysisOptions;